<template>
  <section>
    <q-layout view="hHh lpR fFf">
      <q-header class="header">
        <q-toolbar>
          <q-toolbar-title>
            <!-- <app-header /> -->
            <div class="layout-container">
              <q-icon name="img:/images/auth/logo.svg"></q-icon>
            </div>
          </q-toolbar-title>
        </q-toolbar>
      </q-header>

      <q-page-container>
        <!-- <router-view /> -->
        <app-reset-password-page :actionCode="actionCode" :continueUrl="continueUrl" :lang="lang"
          v-if="mode == 'resetPassword'"></app-reset-password-page>

        <app-verified-email-page :actionCode="actionCode" :continueUrl="continueUrl" :lang="lang"
          v-if="mode == 'verifyEmail'"></app-verified-email-page>
        <app-auth-footer />
      </q-page-container>

      <!-- <q-footer class="">
        <q-toolbar>
          <q-toolbar-title>
            <app-auth-footer />
          </q-toolbar-title>
        </q-toolbar>
      </q-footer> -->
    </q-layout>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import firebase from 'firebase/app';
// import 'firebase/auth';  

import AuthFooter from '@/modules/auth/components/auth-footer'
import ResetPasswordPage from '@/modules/auth/components/reset-password-page'
import VerifiedEmailPage from '@/modules/auth/components/verified-email-page'

export default {
  name: 'app-custom-email-action-handlers-page',

  components: {
    [AuthFooter.name]: AuthFooter,
    [ResetPasswordPage.name]: ResetPasswordPage,
    [VerifiedEmailPage.name]: VerifiedEmailPage,
  },

  created() {
    // Get the action to complete.
    this.mode = this.$route.query.mode
    // Get the one-time code from the query parameter.
    this.actionCode = this.$route.query.oobCode
    // (Optional) Get the continue URL from the query parameter if available.
    this.continueUrl = this.$route.query.continueUrl
    // (Optional) Get the language code if available.
    this.lang = this.$route.query.lang || 'en';
  },

  data() {
    return {
      mode: undefined,
      actionCode: undefined,
      continueUrl: undefined,
      lang: undefined,
    };
  },
  computed: {
    ...mapGetters({
      loading: 'auth/loadingPasswordResetEmail',
      currentLanguageCode: 'layout/currentLanguageCode',
      is_screen_xs: 'layout/is_screen_xs',
    }),
  },
  methods: {
    ...mapActions({

    }),
    i18n(key, args) {
      return this.$t(key, args);
    },
    // async doSubmit() {
    //   try {
    //     await this.$refs.form.validate();
    //   } catch (error) {
    //     return;
    //   }

    //   await this.doSendPasswordResetEmail(this.model.email);
    // },
  },
};
</script>


<style lang="scss">
// .q-page-container {
//   background: #000F3C;
// }
.q-layout {
  min-height: 100vh !important;
}

.q-header {
  background: #da3b30 !important;
  z-index: 2100 !important;

  .q-toolbar {
    // padding: 36px 0 !important;
    padding: 20px 0 !important;
  }

  .q-icon {
    // font-size: 100px !important;
    width: 99px !important;
    height: 72px !important;
  }
}

.header {
  .ellipsis {
    overflow: unset !important;
  }
}

// .q-footer {
//   position: relative !important;
//   background: #000F3C !important;
//   .q-toolbar {
//     padding: unset !important;
//   }
// }
</style>

<style lang="scss" scoped>
// .menu-top {
//   padding: 2.25rem 1.5rem 0 !important;
// }
// .logo {
//   font-size: 1.25rem !important;
//   padding-bottom: 1rem !important;
// }
// .q_container {
//   // background: #f9f9f9 !important;
//   background: #F7F9FA !important;
//   display: block;
//   -webkit-box-flex: 1;
//   -ms-flex: 1;
//   flex: 1;
//   -ms-flex-preferred-size: auto;
//   flex-basis: auto;
//   box-sizing: border-box;
//   padding: 24px 10px; 
//   // padding: calc(20px + (24 - 20) * ((100vw - 375px) / (1440 - 375))) calc(15px + (24 - 15) * ((100vw - 375px) / (1440 - 375))) !important;
// }
// @media (max-width: 400px) {
//   .q_container {
//     padding: 20px 15px !important;
//   }
// }
</style>

